import React, { useEffect, useMemo, useState } from 'react';
import { get_commenti_shortlist } from '../api';
import type { VersioneShortlist } from '../api/types';
import { Commento as CommentoComp } from '../components';
import { useThread } from '../reducers';
import VersioneShortlistFeed from './VersioneShortlistFeed';
import './TimeFeedShortlist.scss';

interface Props {
  threadpk: number;
  versioni: VersioneShortlist[];
}

type Commento = Awaited<ReturnType<typeof get_commenti_shortlist>>[0];

const TimeFeedShortlist = (props: Props) => {
  const threads = useThread(props);
  const [comments, setComments] = useState<Commento[]>([]);
  const [commentError, setCommentError] = useState(false);
  const threadsByProblemId = useMemo(() => new Map(threads.map(thread => [thread.problema.id, thread])), [threads]);

  useEffect(() => {
    let active = true;
    setComments([]);
    setCommentError(false);
    get_commenti_shortlist({ thread: props.threadpk }).then(result => {
      if (active) setComments(result);
    }).catch(() => { if (active) setCommentError(true); });
    return () => { active = false; };
  }, [props.threadpk]);

  // Compare saved versions, independently of comments interleaved in the feed.
  const versions = [...props.versioni].sort((first, second) => first.num - second.num || first.id - second.id);
  const entries = versions.map((version, index) => ({
    key: `version-${version.id}`, date: version.data,
    content: <VersioneShortlistFeed versione={version} precedente={versions[index - 1]} threadsByProblemId={threadsByProblemId} />,
  })).concat(comments.map(comment => ({
    key: `comment-${comment.id}`, date: comment.data,
    content: <CommentoComp commento={comment} shortlist={true} />,
  })));
  entries.sort((first, second) => new Date(first.date).getTime() - new Date(second.date).getTime());

  return <div className="mt-2 shortlist-feed">
    {commentError && <p className="text-warning small" role="alert">Impossibile caricare i commenti. La cronologia delle versioni resta disponibile.</p>}
    {entries.map(entry => <React.Fragment key={entry.key}>{entry.content}</React.Fragment>)}
  </div>;
};

export default TimeFeedShortlist;
